/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum StreamModeEnum {
  Rtmp = "Rtmp",
  Webrtc = "Webrtc",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
